<template>
  <div class="expense-page">
    <LoadingSpinner :visible="isLoading" />
    <!----------------- Main contents Area --------------------->
    <main class="mt-0">
      <div class="p-1">
        <div class="page-header">
          <h2 class="page-title">지 출 품 의 리 스 트</h2>
        </div>

        <!-- ============ 검색조건 카드 ============ -->
        <div class="search-card print-hide">
          <div class="search-card-head">
            <i class="bi bi-funnel"></i> 지출품의서 검색조건
          </div>

          <div class="search-grid">
            <div class="search-field">
              <label>표시기간(발의일기준)</label>
              <input type="month" class="form-control form-control-sm field-input" ref="searchMonth" v-model="this.searchMonth">
            </div>
            <div class="search-field">
              <label>품의번호</label>
              <input type="text" class="form-control form-control-sm field-input" v-model="this.ser_reqCode">
            </div>
            <div class="search-field">
              <label>발의자</label>
              <select class="form-select form-select-sm field-input" v-model="this.chargePerson" ref="dealChargeId">
                <option :value="c.handlerId" :key="i" v-for="(c,i) in this.chargePList">{{ c.handlerNameKor }}</option>
              </select>
            </div>
            <div class="search-field">
              <label>진행상태</label>
              <select class="form-select form-select-sm field-input" aria-label=".form-select-sm" ref="sel_procCode" v-model="rProcCode">
                <option :value="noVal" disabled>진행상태선택</option>
                <option value="A">전체보기</option>
                <option value="lv1">발의</option>
                <option value="lv5">팀장결재</option>
                <option value="lv9">대표결재</option>
                <option value="nay">지출대기</option>
                <option value="pay">지출완료</option>
                <option value="rj5">팀장반려</option>
                <option value="rj9">대표반려</option>
                <option value="lv0">파기</option>
              </select>
            </div>
            <div class="search-field">
              <label>거래처</label>
              <select class="form-select form-select-sm field-input" v-model="this.partner" ref="dealChargeId">
                <option :value="p.pCode" :key="i" v-for="(p,i) in this.partnerList">{{ p.pName }}</option>
              </select>
            </div>
            <div class="search-field">
              <label>거래명/거래코드</label>
              <input type="text" class="form-control form-control-sm field-input" v-model="this.dealName">
            </div>
          </div>

          <div class="search-actions">
            <button type="button" class="btn btn-reset-search" @click="searchDefault">검색조건초기화</button>
            <button type="button" class="btn btn-do-search" @click="searchRequistionData">검색하기</button>
          </div>
        </div>

        <!-- ============ 요약 통계 ============ -->
        <div class="summary-row">
          <div class="summary-stat stat-revenue">
            <div class="stat-label">TOTAL (원화/원화환산)</div>
            <div class="stat-value">₩{{ this.getCurrencyFormat(rPrice_ex_sum) }}</div>
            <div class="stat-sub" v-if="rPrice_sum.JPY || rPrice_sum.USD || rPrice_sum.TWD">
              <span v-if="rPrice_sum.JPY">{{rPrice_sum.JPY.rSymbol }}{{ this.getCurrencyFormat(rPrice_sum.JPY.rPrice_sum) }}</span>
              <span v-if="rPrice_sum.USD"> · US{{rPrice_sum.USD.rSymbol }}{{ this.getCurrencyFormat(rPrice_sum.USD.rPrice_sum) }}</span>
              <span v-if="rPrice_sum.TWD"> · TW{{rPrice_sum.TWD.rSymbol }}{{ this.getCurrencyFormat(rPrice_sum.TWD.rPrice_sum) }}</span>
            </div>
          </div>

          <div class="summary-stat stat-warn">
            <div class="stat-label">미지출건수</div>
            <div class="stat-value">{{ this.notYetPaidCount }} 건</div>
          </div>

          <div class="summary-stat stat-check">
            <div class="stat-label stat-label-row">
              <span>선택합계 (CheckSum)</span>
              <button type="button" class="btn-reset-check" @click="makeNonChecked">선택초기화</button>
            </div>
            <div class="stat-value stat-value-sm">
              <span v-if="checkedSum_ex > 0">₩{{ this.getCurrencyFormat(checkedSum_ex) }}</span>
              <span v-if="checkedSum_jp > 0"> · ¥{{ this.getCurrencyFormat(checkedSum_jp) }}</span>
              <span v-if="checkedSum_us > 0"> · US${{ this.getCurrencyFormat(checkedSum_us) }}</span>
              <span v-if="checkedSum_tw > 0"> · TW${{ this.getCurrencyFormat(checkedSum_tw) }}</span>
              <span class="stat-empty" v-if="!(checkedSum_ex > 0 || checkedSum_jp > 0 || checkedSum_us > 0 || checkedSum_tw > 0)">선택된 항목 없음</span>
            </div>
          </div>
        </div>

        <!-- ============ 리스트 테이블 ============ -->
        <div class="table-wrap">
          <table class="table table-bordered fs-6 data-table" id="reqTable">
            <thead class="small">
              <tr class="text-center">
                <th style="width:3%;">상태</th>
                <th style="width:7%;">발의</th>
                <th style="width:7%;">팀장</th>
                <th style="width:7%;">대표</th>
                <th style="width:7%;">지출완료</th>
                <th style="width:8%;">품의번호</th>
                <th style="width:7%;">거래처</th>
                <th style="width:7%;">
                  <button type="button" class="btn btn-th-action" @click="calcSum_rPrice_ex">원화/원화환산</button>
                </th>
                <th style="width:8%;">
                  <button type="button" class="btn btn-th-action btn-th-action-danger" @click="calcSum_rPrice">외화</button>
                </th>
                <th style="width:6%;">결제시한</th>
                <th style="width:15%;">품의사유</th>
                <th style="width:15%;">행사명/거래코드</th>
                <th style="width:3%;">파기</th>
              </tr>
            </thead>
            <tbody class="small" style="font-size:small;" id="reqTbody">
              <tr :key="i" v-for="(rList, i) in this.reqList" class="text-center">
                <td style="vertical-align: middle;">
                  <span class="chip" :class="(rList.rStat === '팀장반려' || rList.rStat === '대표반려') ? 'chip-danger' : 'chip-neutral'">{{ rList.rStat }}</span>
                </td>

                <td>
                  {{ getDateFormat(rList.check1Date) }}
                  <p class="mb-0 sub-name">({{ rList.checker1Name }})</p>
                </td>

                <td v-if="rList.reqStat === 'rj5' || rList.reqStat === 'rj9'">
                  <div v-if="rList.reject5Date == undefined || rList.reject5Date == null">
                  </div>
                  <div v-else>
                    <a class="reject-link" @click="showComment(rList.reqCode, 'rj5');" style="cursor:pointer;">
                      반려({{ getDateFormat(rList.reject5Date) }})
                    </a>
                    <p class="mb-0 sub-name">({{ rList.checker5Name }})</p>
                  </div>
                </td>

                <td v-else-if="rList.reqStat === 'lv5' || rList.reqStat === 'lv9'">
                  <div v-if="rList.check5Date == undefined || rList.check5Date == null">
                  </div>
                  <div v-else>
                    <span class="approved-text">결재({{ getDateFormat(rList.check5Date) }})</span>
                    <p class="mb-0 sub-name">({{ rList.checker5Name }})</p>
                  </div>
                </td>
                <td v-else>
                </td>

                <td v-if="rList.reqStat === 'rj5' || rList.reqStat === 'rj9'">
                  <div v-if="rList.reject9Date == undefined || rList.reject9Date == null">
                  </div>
                  <div v-else>
                    <a class="reject-link" @click="showComment(rList.reqCode, 'rj9');" style="cursor:pointer;">
                      반려({{ getDateFormat(rList.reject9Date) }})
                    </a>
                    <p class="mb-0 sub-name">({{ rList.checker9Name }})</p>
                  </div>
                </td>
                <td v-else-if="rList.reqStat === 'lv5' || rList.reqStat === 'lv9'">
                  <div v-if="rList.check9Date == undefined || rList.check9Date == null">
                  </div>
                  <div v-else>
                    <span class="approved-text">결재({{ getDateFormat(rList.check9Date) }})</span>
                    <p class="mb-0 sub-name">({{ rList.checker9Name }})</p>
                  </div>
                </td>
                <td v-else>
                </td>

                <td v-if="rList.payDate == null || rList.payDate == undefined" class="dim-cell">–</td>
                <td v-else>
                  <span class="chip chip-success">완료</span>
                  <p class="mb-0 sub-name">{{ getDateFormat(rList.payDate) }} ({{ rList.payerName }})</p>
                </td>

                <td style="vertical-align: middle;">
                  <a class="code-link" @click="goToReqReqView(rList.reqCode);" style="cursor:pointer;">{{ rList.reqCode }}</a>
                </td>
                <td>
                  {{ rList.pName }}
                  <p class="mb-0 sub-name">({{ rList.ptCode }})</p>
                </td>

                <td style="vertical-align: middle; text-align: end;" v-if="rList.rcCode === 'KRW'">
                  <div class="amount-cell">
                    <input class="form-check-input" type="checkbox"  v-model="rList.checked_ex">
                    <span>{{ rList.rSymbol }}{{ getCurrencyFormat(rList.rPrice) }}</span>
                  </div>
                </td>
                <td style="vertical-align: middle; text-align: end;" v-else>
                  <div class="amount-cell">
                    <input class="form-check-input" type="checkbox" v-model="rList.checked_ex">
                    <span class="dim-cell">₩{{ getCurrencyFormat(rList.rPrice_ex) }}</span>
                  </div>
                </td>

                <td style="vertical-align: middle; text-align: end;" v-if="rList.rcCode != 'KRW'">
                  <div class="amount-cell">
                    <input class="form-check-input" type="checkbox" v-model="rList.checked">
                    <span>{{ rList.rSymbol }}{{ getCurrencyFormat(rList.rPrice) }}</span>
                  </div>
                </td>
                <td style="vertical-align: middle; text-align: end;" v-else class="dim-cell">0</td>

                <td v-if="rList.ttlDate == null || rList.ttlDate == undefined" class="dim-cell">–</td>
                <td style="vertical-align:middle;" v-else>
                  {{ this.getDateFormat(rList.ttlDate) }}
                </td>

                <td class="text-start ellipsis-cell" :title="rList.reqRemarks">
                  {{ rList.reqRemarks }}
                </td>

                <td class="text-start ellipsis-cell" :title="rList.dealNameKor">
                  {{ rList.dealNameKor }}
                  <p class="mb-0 deal-code-link" @click="goToBizInfoDetail(rList.dealCode);">({{ rList.dealCode }})</p>
                </td>
                <td>
                  <span v-if="user.handlerGrade > 5 && (rList.reqStat === 'lv5' || rList.reqStat === 'lv9')">
                  </span>
                  <button type="button" class="btn btn-discard-sm" v-else-if="rList.reqStat === 'lv0'" disabled>
                    <i class="bi bi-trash3"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import LoadingSpinner from '../components/LoadingSpinner.vue'
import dayjs from "dayjs"

export default {
  components: {
    LoadingSpinner
  },
  data() {
    return {
      isLoading: false,

      reqList: [],

      result: null,
      arrSearchData: [],

      //fullPayFlag: ""             //완불여부 (fp: 완불)
      noDispCxl: false,             //취소예약비표시

      reqPriceList: [],             //지품금액 리스트
      reqList1: [],                 //진행상태처리용
      reqPriceList1: [],

      chargePList: [],              //발의자리스트
      partnerList: [],              //파트너리스트
      //검색조건
      searchMonth: dayjs().format('YYYY-MM'),              //검색기준월
      searchStart: "",              //검색기준일
      searchEnd: "",
      ser_reqCode: "",              //품의코드
      chargePerson: "",             //발의자
      rProcCode: "",                //진행상태
      partner: "",                  //파트너
      dealName: "",                 //거래정보

      rPrice_sum: 0,                //품의액합산
      rPrice_ex_sum: 0,             //원화환산합산

      checkedSum_jp: 0,             // 엔화합산 결과를 저장할 변수
      checkedSum_us: 0,             // 미화합산 결과를 저장할 변수
      checkedSum_tw: 0,             // 타이완달라합산 결과를 저장할 변수
      //checkedSum: null,             // 합산 결과를 저장할 변수
      checkedSum_ex: 0,             // 환산합산 결과를 저장할 변수

      notYetPaidCount: 0,           // 미지출품의 카운트
      

      // expRptPriceList_sum: [],      //품의액 합산
      // expRptPriceList_sum1: [],     //진행상태처리용

    };
  },
  created() {
    this.getExpRptList()

    this.getRequesterList()             //발의자리스트
    this.getPartnerList()               //거래처리스트


    //console.log("AccessInfo:",this.$store.state.user); 
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20 || this.user.handlerGrade == undefined) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }

    ////document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";
  },

  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value)
    {
      return this.$currencyFormat(value);
    },

    //검색조건 초기화
    searchDefault(){
      this.searchStart = ""
      this.searchEnd   = ""
      this.searchMonth = dayjs().format('YYYY-MM') // 현재 월로 초기화  
      this.ser_reqCode = ""
      this.chargePerson= ""
      this.rProcCode   = ""
      this.partner     = ""
      this.dealName    = ""
    },

    //발의자리스트
    async getRequesterList(){
      let chargePList = await this.$api("/api/handlerInfo", {})
      if(chargePList.length > 0)
      {
        this.chargePList = chargePList;
      }
    },

    //거래처리스트
    async getPartnerList(){
      let partnerList = await this.$api("/api/partnerInfo", {})
      if(partnerList.length > 0)
      {
        this.partnerList = partnerList;
      }
    },    

    //선택초기화
    makeNonChecked(){
      this.reqList.forEach(item => {
        item.checked = false;
        item.checked_ex = false;
      });

      this.checkedSum_ex = 0
      this.checkedSum_jp = 0
      this.checkedSum_us = 0
      this.checkedSum_tw = 0
    },

    //체크외화 합산
    calcSum_rPrice(){
      // 체크된 항목의 `rPrice_ex`만 합산
      // let sum = this.reqList.reduce((acc, item) => {
      //   if(item.checked && item.rcCode != "KRW")
      //   {
      //     if(!acc[item.rcCode])
      //     {
      //       acc[item.rcCode].rPrice_sum += item.rPrice
      //     }
      //     return acc
      //   }
      // })

      let sum_jp = this.reqList
        .filter(item => (item.checked && item.rcCode === "JPY"))         //체크된 금액만 추출
        .reduce((acc, item) => acc + Number(item.rPrice || 0), 0)
      // 결과 저장
      this.checkedSum_jp = sum_jp;

      let sum_us = this.reqList
        .filter(item => (item.checked && item.rcCode === "USD"))         //체크된 금액만 추출
        .reduce((acc, item) => acc + Number(item.rPrice || 0), 0)
      // 결과 저장
      this.checkedSum_us = sum_us;      

      let sum_tw = this.reqList
        .filter(item => (item.checked && item.rcCode === "TWD"))         //체크된 금액만 추출
        .reduce((acc, item) => acc + Number(item.rPrice || 0), 0)
      // 결과 저장
      this.checkedSum_tw = sum_tw;

      // console.log("sum_jp:",sum_jp, "sum_us:",sum_us, "sum_tw:",sum_tw)
      // console.log('체크된 항목의 합산된 엔화값:', this.checkedSum_jp, '체크된 항목의 합산된 타이완값:', this.checkedSum_tw);
    },

    //체크환산 합산
    calcSum_rPrice_ex() {
      // 체크된 항목의 `rPrice_ex`만 합산
      let sum_ex = this.reqList
        .filter(item => item.checked_ex)         //체크된 금액만 추출
        .reduce((acc, item) => acc + Number(item.rPrice_ex || 0), 0)  // ← Number() 추가

      // 결과 저장
      this.checkedSum_ex = sum_ex;
      //console.log('체크된 항목의 합산된 원화/원화환산 값:', this.checkedSum_ex);
    },

    async getExpRptList(){
      let id = this.user.handlerId
      let level = this.user.handlerGrade
      //console.log("level:", level)
      
      this.isLoading = true      //로딩시작

      try 
      {
        let expRptList = []
        let expRptPriceList = []

        // 기본표시: 1달간 품의서 표시
        if(level <= 6)
        {
          expRptList = await this.$api("/api/expRptListForLeader", {});
          expRptPriceList = await this.$api("/api/exRptPriceListForLeader", {});
          //expRptPriceList_sum = await this.$api("/api/exRptPriceListForLeader_sum", {});          //합산액
        }
        else
        {
          expRptList = await this.$api("/api/expRptList", { param: [id] });
          expRptPriceList = await this.$api("/api/exRptPriceList", { param: [id] });
          //expRptPriceList_sum = await this.$api("/api/exRptPriceList_sum", { param: [id] });
        }
        //초기표시에는 파기품의 비표시
        expRptList = expRptList.filter(e => {
          return e.reqStat != "lv0"
        })

        expRptPriceList = expRptPriceList.filter(e => {
          return e.reqStat != "lv0"
        })

        if(expRptList.length > 0) {
          //this.reqList = expRptList
          this.reqList = expRptList.map(item => ({
            ...item,
            checked: false // 처음에 모두 체크 해제
          }));
        }

        if(expRptPriceList.length > 0) {
          this.reqPriceList = expRptPriceList
        }

        //추출한 품의금액리스트 객체를 품의리스트에 합병
        for(let i=0; i<expRptList.length; i++)
        {
          this.reqList[i] = {
            ...this.reqList[i],
            ...this.reqPriceList[i]
          }
        }

        //파기품의 표시유무체크
        if(this.noDispCxl === true)
        {
          this.reqList = this.reqList.filter(e => {
            return e.reqStat != "lv0"
          })
        }

        // (수정) TOTAL은 검색월(searchMonth)에 한정한 금액만 집계
        // reqList 자체(테이블 표시, 미지출건수 집계용)는 그대로 두고, TOTAL 계산에만 발의일 기준 월 필터를 적용
        // - 초기표시 API(expRptList/expRptListForLeader)는 월 파라미터 없이 호출되기 때문에,
        //   백엔드가 반환하는 기본범위가 화면에 표시된 검색월(searchMonth)과 정확히 일치한다는 보장이 없음
        let monthMatched = this.reqList.filter(item => {
          let check1Date = item.check1Date ? item.check1Date.substring(0, 7) : ''
          return (this.searchMonth === '' || check1Date === this.searchMonth)
        })

        //품의액 합산
        let rPrice_sum_tmp = monthMatched.reduce((acc, item) => {       //acc:누적값
          //KRW는 제외
          if(item.rcCode != "KRW")
          {
            if(!acc[item.rcCode])
            {
              acc[item.rcCode] = { rPrice_sum: 0, rcCode: item.rcCode, rSymbol: item.rSymbol }
            }
            acc[item.rcCode].rPrice_sum += Number(item.rPrice || 0) 
          }
          return acc
        }, {})

        //배열형태로 변환
        //let rPrice_sum = Object.values(rPrice_sum_tmp)
        this.rPrice_sum = rPrice_sum_tmp

        //품의액 원화환산 합산 (검색월 한정)
        // let rPrice_ex_sum = this.reqList.reduce((acc, item) => acc + item.rPrice_ex, 0)
        // js로 넘어올 때 문자로 바뀌는 경우가 있어서, 숫자로 변환하여 합산 처리(number함수는 숫자가 아니면 작업중단)
        let rPrice_ex_sum = monthMatched.reduce((acc, item) => acc + Number(item.rPrice_ex || 0), 0)
        this.rPrice_ex_sum = rPrice_ex_sum

        let notYetPaidCount = 0
        notYetPaidCount = Object.values(monthMatched).filter(item => (item.payDate == null || item.payDate == undefined) && item.reqStat != "lv0").length
        this.notYetPaidCount = (notYetPaidCount == undefined || notYetPaidCount < 0) ? "0" : notYetPaidCount
      }
      finally
      {
        this.isLoading = false          //로딩종료
      }
    },
    
    showComment(qCode, r){
      let res = this.reqList.filter(item => {
        return item.reqCode === qCode
      })

      let rejectComment = ""
      if(r === "rj5")
      {
        rejectComment = res[0].rejectLv5
      }
      else if(r === "rj9")
      {
        rejectComment = res[0].rejectLv9
      }
      this.$swal.fire("반려사유", rejectComment, "")
    },

    // goToReqReqView(rCode) {
    //   this.$router.push({path: '/expenseReportView', query: {rCode: rCode}});
    // },

    //새로운 탭으로
    goToReqReqView(rCode) {
      const url = this.$router.resolve({ path: '/expenseReportView', query: { rCode } }).href;
      window.open(url, '_blank'); // 새 탭에서 열기
    },


    //거래상세정보로 이동
    goToBizInfoDetail(dCode) {
      const url = this.$router.resolve({path: '/businessInfo_detail', query: {dCode: dCode}}).href;
      window.open(url, '_blank'); // 새 탭에서 열기
    },    

    //품의서 검색
    async searchRequistionData(){
      this.makeNonChecked()

      // if(this.searchStart)
      // {
      //   if(!this.searchEnd)
      //   {
      //     this.$swal.fire("","종료일이 누락되었습니다", "warning")
      //     return false
      //   }
      // }
      // if(this.searchEnd)
      // {
      //   if(!this.searchStart)
      //   {
      //     this.$swal.fire("","시작일이 누락되었습니다", "warning")
      //     return false
      //   }
      // }      
      await this.getExpRptList1();

      //검색조건
      // let searchStart   = (!this.searchStart ) ? "" : this.searchStart.replace(/-/g, "")
      // let searchEnd     = (!this.searchEnd   ) ? "" : this.searchEnd.replace(/-/g, "")
      let searchMonth   = (!this.searchMonth ) ? "" : this.searchMonth
      let ser_reqCode   = (!this.ser_reqCode ) ? "" : this.ser_reqCode              //품의코드
      let chargePerson  = (!this.chargePerson) ? "" : this.chargePerson             //발의자
      let rProcCode     = (!this.rProcCode   ) ? "" : this.rProcCode                //진행상태
      let partner       = (!this.partner     ) ? "" : this.partner                  //파트너
      let dealName      = (!this.dealName    ) ? "" : this.dealName                 //거래정보

      if(this.rProcCode === "nay")
      {
        this.reqList1 = this.reqList1.filter(e => {
          // let check1Date = this.getDateFormat(e.check1Date).replace(/-/g, "")
          let check1Date = e.check1Date.substring(0, 7) // YYYY-MM 형식으로 자르기
          //console.log("check1Date:", check1Date, "searchMonth:", searchMonth)
          return (
            //발의일자검색(날짜가 없으면 넘어감)
            // ((searchStart === "" && searchEnd === "") || (check1Date >= searchStart && check1Date <= searchEnd)) &&
            ((searchMonth == "") || (check1Date == searchMonth)) &&
            //품의코드(없으면 넘어감)
            (ser_reqCode == "" || e.reqCode === ser_reqCode) &&
            //발의자검색
            (chargePerson == "" || e.checker1Id === chargePerson) &&
            // 진행상태 검색 조건 확인(지출대기는 파기X+미지출)
            // ((e.payDate == null || e.payDate == undefined) && e.reqStat != 'lv0' && (e.checker9Id != null || e.checker9Id != undefined)) &&
            ((e.payDate == null || e.payDate == undefined) && e.reqStat != 'lv0') &&
            // 파트너 검색 조건 확인
            (partner === "" || e.ptCode === partner) &&
            // 거래정보 검색 조건 확인
            (dealName === "" || e.dealNameKor === dealName || e.dealCode === dealName)
          )
        })
      }
      else if(this.rProcCode === "pay")
      {
        this.reqList1 = this.reqList1.filter(e => {
          // let check1Date = this.getDateFormat(e.check1Date).replace(/-/g, "")
          let check1Date = e.check1Date.substring(0, 7) // YYYY-MM 형식으로 자르기

          return (
            //발의일자검색(날짜가 없으면 넘어감)
            // ((searchStart === "" && searchEnd === "") || (check1Date >= searchStart && check1Date <= searchEnd)) &&
            ((searchMonth == "") || (check1Date == searchMonth)) &&
            //품의코드(없으면 넘어감)
            (ser_reqCode == "" || e.reqCode === ser_reqCode) &&
            //발의자검색
            (chargePerson == "" || e.checker1Id === chargePerson) &&
            // 진행상태 검색 조건 확인
            ((e.payDate != null || e.payDate != undefined) && e.reqStat != 'lv0'  && (e.checker9Id != null || e.checker9Id != undefined)) &&
            // 파트너 검색 조건 확인
            (partner === "" || e.ptCode === partner) &&
            // 거래정보 검색 조건 확인
            (dealName === "" || e.dealNameKor === dealName || e.dealCode === dealName)
          )
        })
      }
      else if(this.rProcCode === "A")
      {
        this.reqList1 = this.reqList1.filter(e => {
          // let check1Date = this.getDateFormat(e.check1Date).replace(/-/g, "")
          let check1Date = e.check1Date.substring(0, 7) // YYYY-MM 형식으로 자르기

          return (
            //발의일자검색(날짜가 없으면 넘어감)
            // ((searchStart === "" && searchEnd === "") || (check1Date >= searchStart && check1Date <= searchEnd)) &&
            ((searchMonth == "") || (check1Date == searchMonth)) &&
            //품의코드(없으면 넘어감)
            (ser_reqCode == "" || e.reqCode === ser_reqCode) &&
            //발의자검색
            (chargePerson == "" || e.checker1Id === chargePerson) &&
            // 진행상태 검색 조건 확인(전체보기포함)
            (rProcCode === "" || rProcCode === "A" || e.reqStat === rProcCode) &&
            // 파트너 검색 조건 확인
            (partner === "" || e.ptCode === partner) &&
            //파기는 제외
            (e.reqStat != "lv0") &&
            // 거래정보 검색 조건 확인
            (dealName === "" || e.dealNameKor === dealName || e.dealCode === dealName)
          )
        })
      }      
      else
      {
        this.reqList1 = this.reqList1.filter(e => {
          // let check1Date = this.getDateFormat(e.check1Date).replace(/-/g, "")
          let check1Date = e.check1Date.substring(0, 7) // YYYY-MM 형식으로 자르기

          return (
            //발의일자검색(날짜가 없으면 넘어감)
            // ((searchStart === "" && searchEnd === "") || (check1Date >= searchStart && check1Date <= searchEnd)) &&
            ((searchMonth == "") || (check1Date == searchMonth)) &&
            //품의코드(없으면 넘어감)
            (ser_reqCode == "" || e.reqCode === ser_reqCode) &&
            //발의자검색
            (chargePerson == "" || e.checker1Id === chargePerson) &&
            // 진행상태 검색 조건 확인(전체보기포함)
            (rProcCode === "" || rProcCode === "A" || e.reqStat === rProcCode) &&
            // 파트너 검색 조건 확인
            (partner === "" || e.ptCode === partner) &&
            // 거래정보 검색 조건 확인
            (dealName === "" || e.dealNameKor === dealName || e.dealCode === dealName)
          )
        })
      }
      //파기품의 표시유무체크
      if(this.noDispCxl === true)
      {
        this.reqList1 = this.reqList1.filter(e => {
          return e.reqStat != "lv0"
        })
      }
      else
      {
        this.reqList = this.reqList1
        // this.expRptPriceList_sum = this.expRptPriceList_sum1
      }

      //품의액 합산
      // let rPrice_sum_tmp = this.reqList.reduce((acc, item) => {       //acc:누적값
      //   //KRW는 제외
      //   if(item.rcCode != "KRW")
      //   {
      //     if(!acc[item.rcCode])
      //     {
      //       acc[item.rcCode] = { rPrice_sum: 0, rcCode: item.rcCode, rSymbol: item.rSymbol }
      //     }
      //     acc[item.rcCode].rPrice_sum += item.rPrice
      //   }
      //   return acc
      // }, {})

      // js로 넘어올 때 문자로 바뀌는 경우가 있어서, 숫자로 변환하여 합산 처리(number함수는 숫자가 아니면 작업중단)
      let rPrice_sum_tmp = this.reqList.reduce((acc, item) => {
        if(item.rcCode != "KRW") {
          if(!acc[item.rcCode]) {
            acc[item.rcCode] = { rPrice_sum: 0, rcCode: item.rcCode, rSymbol: item.rSymbol }
          }
          acc[item.rcCode].rPrice_sum += Number(item.rPrice || 0)  // ← 여기도!
        }
        return acc
      }, {})

      //배열형태로 변환
      //let rPrice_sum = Object.values(rPrice_sum_tmp)
      this.rPrice_sum = rPrice_sum_tmp

      //품의액 원화환산 합산
      let rPrice_ex_sum = this.reqList.reduce((acc, item) => acc + Number(item.rPrice_ex || 0), 0)
      this.rPrice_ex_sum = rPrice_ex_sum

      let notYetPaidCount = 0
      //const count = Object.values(data).filter(item => item.payDate === "").length;
      notYetPaidCount = Object.values(this.reqList).filter(item => (item.payDate == null || item.payDate == undefined) && item.reqStat != "lv0").length
      this.notYetPaidCount = (notYetPaidCount == undefined || notYetPaidCount < 0) ? "0" : notYetPaidCount
      // console.log("notYetPaidCount:", this.notYetPaidCount)
      //console.log("reqList:", this.reqList)
    },

    //선택조건 처리용
    async getExpRptList1(){
      let id = this.user.handlerId
      let level = this.user.handlerGrade
      
      let expRptList1 = []
      let expRptPriceList1 = []
      //let expRptPriceList_sum1 = []

      if(level <= 5)
      {
        expRptList1 = await this.$api("/api/expRptListForLeader_search", { param: [this.searchMonth] });
        expRptPriceList1 = await this.$api("/api/exRptPriceListForLeader_search", { param: [this.searchMonth] });
        //expRptPriceList_sum1 = await this.$api("/api/exRptPriceListForLeader_sum", {});          //합산액
      }
      else
      {
        expRptList1 = await this.$api("/api/expRptList_search", { param: [id, this.searchMonth] });
        expRptPriceList1 = await this.$api("/api/exRptPriceList_search", { param: [id, this.searchMonth] });
        //expRptPriceList_sum1 = await this.$api("/api/exRptPriceList_sum", { param: [id] });
      }

      // //기본표시는 파기품의 비표시
      // expRptList1 = expRptList1.filter(e => {
      //   return e.reqStat != "lv0"
      // })

      // expRptPriceList1 = expRptPriceList1.filter(e => {
      //   return e.reqStat != "lv0"
      // })

      if(expRptList1.length > 0) {
        this.reqList1 = expRptList1
      }

      if(expRptPriceList1.length > 0) {
        this.reqPriceList1 = expRptPriceList1
      }

      //추출한 품의금액리스트 객체를 품의리스트에 합병
      for(let i=0; i<expRptList1.length; i++)
      {
        this.reqList1[i] = {
          ...this.reqList1[i],
          ...this.reqPriceList1[i]
        }
      }

      //console.log("reqList1:::::::", this.reqList1)

      // //파기품의 표시유무체크
      // if(this.noDispCxl === true)
      // {
      //   this.reqList1 = this.reqList1.filter(e => {
      //     return e.reqStat != "lv0"
      //   })
      // }
    },
  }
}
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');

.expense-page {
  --ink: #0f1720;
  --muted: #3d4652;
  --paper: #f4f6f8;
  --card: #ffffff;
  --line: #d7dce2;
  --accent: #0a6169;
  --accent-soft: #dcf0ef;
  --warn: #a85f14;
  --warn-soft: #fbe8cf;
  --danger: #a52e27;
  --danger-soft: #f8dad8;
  --success: #1f6e44;
  --success-soft: #d9f0e4;

  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Malgun Gothic', sans-serif;
  color: var(--ink);
  background: var(--paper);
  min-height: 100%;
  padding: 0.75rem;
}

.page-header { text-align: center; margin-bottom: 0.5rem; }
.page-title {
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 0.15em;
  color: var(--ink);
  display: inline-block;
  border-bottom: 3px solid var(--accent);
  padding-bottom: 0.2rem;
}

/* ---------- 검색조건 카드 ---------- */
.search-card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 0.5rem 0.9rem;
  margin-bottom: 0.5rem;
  box-shadow: 0 1px 3px rgba(20,30,40,0.05);
}
.search-card-head {
  font-weight: 700;
  color: var(--accent);
  font-size: 0.82rem;
  margin-bottom: 0.4rem;
  text-align: left;
}
.search-card-head i { margin-right: 0.3rem; }

.search-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 0.4rem 0.7rem;
}
.search-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  text-align: left;
}
.search-field label {
  font-size: 0.74rem;
  font-weight: 700;
  color: var(--muted);
  flex: 0 0 auto;
  white-space: nowrap;
}
.field-input {
  border: 1px solid var(--line);
  border-radius: 8px;
  border-left: 3px solid var(--accent);
  font-size: 0.82rem;
  flex: 1;
  min-width: 0;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}
.field-input:focus { border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-soft); }

.search-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.btn-reset-search {
  background: var(--paper);
  border: 1px solid var(--line);
  color: var(--muted);
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.78rem;
  padding: 0.25rem 0.7rem;
}
.btn-do-search {
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.78rem;
  padding: 0.25rem 0.9rem;
}
.btn-do-search:hover { filter: brightness(1.08); }

/* ---------- 요약 통계 ---------- */
.summary-row {
  display: grid;
  grid-template-columns: 1.3fr 0.8fr 1.3fr;
  gap: 0.5rem;
  margin-bottom: 0.6rem;
}
.summary-stat {
  background: var(--card);
  border: 1px solid var(--line);
  border-left: 4px solid var(--line);
  border-radius: 10px;
  padding: 0.4rem 0.8rem;
  box-shadow: 0 1px 3px rgba(20,30,40,0.05);
  text-align: left;
}
.stat-label { font-size: 0.72rem; font-weight: 700; color: var(--muted); margin-bottom: 0.1rem; }
.stat-label-row { display: flex; align-items: center; justify-content: space-between; }
.stat-value { font-size: 1rem; font-weight: 800; color: var(--ink); }
.stat-value-sm { font-size: 0.86rem; font-weight: 700; }
.stat-sub { font-size: 0.75rem; color: var(--muted); margin-top: 0.1rem; }
.stat-empty { color: var(--muted); font-weight: 500; font-size: 0.8rem; }

.stat-revenue { border-left-color: var(--accent); }
.stat-revenue .stat-value { color: var(--accent); }
.stat-warn { border-left-color: var(--warn); }
.stat-warn .stat-value { color: var(--warn); }
.stat-check { border-left-color: var(--success); }
.stat-check .stat-value { color: var(--success); }

.btn-reset-check {
  border: none;
  background: transparent;
  color: var(--muted);
  font-size: 0.72rem;
  font-weight: 700;
  text-decoration: underline;
  padding: 0;
  cursor: pointer;
}
.btn-reset-check:hover { color: var(--danger); }

/* ---------- 테이블 ---------- */
.table-wrap {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 12px;
  overflow: auto;
  max-height: 72vh;
  box-shadow: 0 1px 3px rgba(20,30,40,0.05);
}
.data-table { margin-bottom: 0; border: none; }
.data-table thead th {
  position: sticky;
  top: 0;
  z-index: 5;
  background: #eef1f3;
  color: var(--ink);
  font-weight: 700;
  border-color: var(--line) !important;
  box-shadow: 0 1px 0 var(--line);
  vertical-align: middle;
}
.data-table tbody td {
  border-color: var(--line) !important;
  color: var(--ink);
  vertical-align: middle;
}
.data-table tbody tr:nth-child(even) { background: #fafbfc; }
.data-table tbody tr:hover { background: var(--accent-soft); }

.btn-th-action {
  background: var(--accent-soft);
  color: var(--accent);
  border: none;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.25rem 0.5rem;
}
.btn-th-action:hover { background: var(--accent); color: #fff; }
.btn-th-action-danger { background: var(--danger-soft); color: var(--danger); }
.btn-th-action-danger:hover { background: var(--danger); color: #fff; }

.sub-name { font-size: 0.74rem; color: var(--muted); }
.dim-cell { color: var(--muted); }

.chip {
  display: inline-block;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 700;
  white-space: nowrap;
}
.chip-neutral { background: #eceef1; color: var(--ink); }
.chip-danger { background: var(--danger-soft); color: var(--danger); }
.chip-success { background: var(--success-soft); color: var(--success); }

.reject-link { color: var(--danger); font-weight: 700; text-decoration: none; }
.reject-link:hover { text-decoration: underline; }
.approved-text { color: var(--success); font-weight: 600; font-size: 0.85rem; }

.code-link { font-weight: 700; color: var(--accent); text-decoration: none; }
.code-link:hover { text-decoration: underline; }

.deal-code-link { font-size: 0.76rem; color: var(--accent); cursor: pointer; }
.deal-code-link:hover { text-decoration: underline; }

.amount-cell { display: flex; justify-content: space-between; align-items: center; gap: 0.4rem; }

.ellipsis-cell {
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-discard-sm {
  background: var(--danger-soft);
  color: var(--danger);
  border: none;
  border-radius: 6px;
  padding: 0.2rem 0.5rem;
  opacity: 0.6;
}

/* ---------- 인쇄 ---------- */
@media print {
  .print-hide { display: none !important; }
  .table-wrap { max-height: none !important; overflow: visible !important; }
  .data-table thead th { position: static !important; box-shadow: none !important; }
}

@media (max-width: 1300px) {
  .search-grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 1000px) {
  .summary-row { grid-template-columns: 1fr; }
}
@media (max-width: 700px) {
  .search-grid { grid-template-columns: repeat(2, 1fr); }
  .search-field { flex-direction: column; align-items: flex-start; gap: 0.15rem; }
}
</style>